var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_2247_12391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9121 47.5928H88.0879V82.3641H11.9121V47.5928Z",
    fill: "#E19974"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.07227 96.1316V47.3154H15.7504V96.1316C15.7504 97.0156 15.0338 97.7322 14.1498 97.7322H9.67285C8.78887 97.7322 8.07227 97.0156 8.07227 96.1316Z",
    fill: "#C86D36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.249 96.1316V47.3154H91.9271V96.1316C91.9271 97.0156 91.2105 97.7322 90.3266 97.7322H85.8496C84.9656 97.7322 84.249 97.0156 84.249 96.1316Z",
    fill: "#AC5E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6982 47.3143H9.49023C8.60625 47.3143 7.88965 46.5977 7.88965 45.7137V33.3105C7.88965 32.4266 8.60625 31.71 9.49023 31.71H33.6982C34.5822 31.71 35.2988 32.4266 35.2988 33.3105V45.7137C35.2986 46.5977 34.582 47.3143 33.6982 47.3143Z",
    fill: "#0067C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4926 30.9043H67.7715H60.0504L58.4619 45.7166H67.7715H77.0811L75.4926 30.9043Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2307 0H46.3119C44.7217 0 43.4326 1.28906 43.4326 2.8793V30.5996H92.11V2.8793C92.11 1.28906 90.8209 0 89.2307 0V0Z",
    fill: "#D3E1F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.11 33.2076V25.1123H43.4326V33.2076C43.4326 34.7979 44.7217 36.0869 46.3119 36.0869H89.2307C90.8209 36.0869 92.11 34.7977 92.11 33.2076Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9154 51.6338H2.08379C1.08926 51.6338 0.283203 50.8275 0.283203 49.8332V44.7967C0.283203 43.8021 1.08945 42.9961 2.08379 42.9961H97.9154C98.91 42.9961 99.716 43.8023 99.716 44.7967V49.8332C99.716 50.8275 98.91 51.6338 97.9154 51.6338Z",
    fill: "#9E5528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2307 0H81.291C82.8813 0 84.1703 1.28906 84.1703 2.8793V30.5996H92.11V2.8793C92.11 1.28906 90.8209 0 89.2307 0V0Z",
    fill: "#C0D6F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1703 25.1123V33.2076C84.1703 34.7979 82.8813 36.0869 81.291 36.0869H89.2307C90.8209 36.0869 92.11 34.7979 92.11 33.2076V25.1123H84.1703Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9152 42.9961H89.9756C90.9699 42.9961 91.7762 43.8023 91.7762 44.7967V49.8334C91.7762 50.8279 90.9699 51.634 89.9756 51.634H97.9152C98.9098 51.634 99.7158 50.8279 99.7158 49.8334V44.7967C99.7158 43.8023 98.9098 42.9961 97.9152 42.9961Z",
    fill: "#904D24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9176 45.891H37.8369C34.5594 45.891 31.9023 43.234 31.9023 39.9564V25.5439C31.9023 22.2664 34.5594 19.6094 37.8369 19.6094H61.9174C65.1949 19.6094 67.852 22.2664 67.852 25.5439V39.9564C67.852 43.2342 65.1951 45.891 61.9176 45.891Z",
    fill: "#CA2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1201 67.4375H52.8787V80.6627H47.1201V67.4375Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1996 94.3148C67.6527 94.3148 66.3986 93.0607 66.3986 91.5139V84.7316C66.3986 84.0322 65.8297 83.4631 65.1301 83.4631H34.6254C33.926 83.4631 33.3568 84.032 33.3568 84.7316V91.5139C33.3568 93.0607 32.1027 94.3148 30.5559 94.3148C29.009 94.3148 27.7549 93.0607 27.7549 91.5139V84.7316C27.7549 80.9434 30.8369 77.8613 34.6252 77.8613H65.1299C68.9182 77.8613 72.0002 80.9434 72.0002 84.7316V91.5139C72.0006 93.0607 70.7465 94.3148 69.1996 94.3148Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9992 94.3307C48.4523 94.3307 47.1982 93.0766 47.1982 91.5297V80.6779C47.1982 79.1311 48.4523 77.877 49.9992 77.877C51.5461 77.877 52.8002 79.1311 52.8002 80.6779V91.5297C52.8002 93.0768 51.5461 94.3307 49.9992 94.3307Z",
    fill: "#9C9C9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2512 99.9998H28.86C27.7361 99.9998 26.8252 99.0889 26.8252 97.965V91.4088C26.8252 90.285 27.7361 89.374 28.86 89.374H32.2512C33.375 89.374 34.2859 90.285 34.2859 91.4088V97.965C34.2859 99.0889 33.375 99.9998 32.2512 99.9998Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6857 99.9998H48.2945C47.1709 99.9998 46.2598 99.0889 46.2598 97.965V91.4088C46.2598 90.285 47.1707 89.374 48.2945 89.374H51.6857C52.8096 89.374 53.7205 90.285 53.7205 91.4088V97.965C53.7203 99.0889 52.8094 99.9998 51.6857 99.9998Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1375 71.5924H34.617C31.5736 71.5924 29.1064 69.1252 29.1064 66.0818C29.1064 63.0385 31.5736 60.5713 34.617 60.5713H65.1375C68.1809 60.5713 70.648 63.0385 70.648 66.0818C70.648 69.1252 68.1809 71.5924 65.1375 71.5924Z",
    fill: "#CA2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2504 66.2391H49.7482C48.2967 66.2391 47.1201 65.0623 47.1201 63.6109V41.2268C47.1201 39.7752 48.2967 38.5986 49.7482 38.5986H50.2504C51.702 38.5986 52.8785 39.7752 52.8785 41.2268V63.6109C52.8785 65.0625 51.7018 66.2391 50.2504 66.2391Z",
    fill: "#838383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9182 19.6094H53.9785C57.2561 19.6094 59.9131 22.2662 59.9131 25.5439V39.9564C59.9131 43.234 57.2561 45.891 53.9785 45.891H61.9182C65.1957 45.891 67.8527 43.2342 67.8527 39.9564V25.5439C67.8525 22.2664 65.1957 19.6094 61.9182 19.6094Z",
    fill: "#A72B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1379 60.5713H57.1982C60.2416 60.5713 62.7088 63.0385 62.7088 66.0818C62.7088 69.1252 60.2416 71.5924 57.1982 71.5924H65.1379C68.1813 71.5924 70.6484 69.1252 70.6484 66.0818C70.6484 63.0385 68.1813 60.5713 65.1379 60.5713Z",
    fill: "#A72B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1301 77.8613H57.1904C60.5453 77.8613 63.3443 80.2791 63.9414 83.4631H65.1301C65.8295 83.4631 66.3986 84.032 66.3986 84.7316V91.5139C66.3986 93.0607 67.6527 94.3148 69.1996 94.3148C70.7465 94.3148 72.0006 93.0607 72.0006 91.5139V84.7316C72.0004 80.9434 68.9184 77.8613 65.1301 77.8613Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8947 99.9998H67.5035C66.3797 99.9998 65.4688 99.0889 65.4688 97.965V91.4088C65.4688 90.285 66.3797 89.374 67.5035 89.374H70.8947C72.0186 89.374 72.9295 90.285 72.9295 91.4088V97.965C72.9295 99.0889 72.0186 99.9998 70.8947 99.9998Z",
    fill: "#383838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2247_12391"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkplace);
export default __webpack_public_path__ + "static/media/workplace.21fda243954441e3581cd5eb9305cfbc.svg";
export { ForwardRef as ReactComponent };